import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState:any = {}

const topUpProduct = createSlice({
  name: 'topUpProduct',
  initialState,
  reducers: {
    setTopUpProducts(state,action:PayloadAction<any>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default topUpProduct.reducer;

// Actions
export const {setTopUpProducts} = topUpProduct.actions;

